<script>
import { mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

import vSelect from "vue-select";

export default {
  data: () => ({
    errors: {
      email: {
        active: false,
        message: "",
      },
      password: {
        active: false,
        message: "",
      },
      name: {
        active: false,
        message: "",
      },
      last_name: {
        active: false,
        message: "",
      },
      postal_code: {
        active: false,
        message: "",
      },
      year: {
        active: false,
        message: "",
      },
      model: {
        active: false,
        message: "",
      },
      brand: {
        active: false,
        message: "",
      },
    },
    years: [],
    brands: [],
    models: [],
    err: [],
    email: "",
    password: "",
    name: "",
    last_name: "",
    postal_code: "",
    year: "",
    model: "",
    brand: "",
    type: "agencia",
    loadingBrand: false,
    loadingModel: false,
    loading: false,
    registered: false,
    error: "",
  }),
  methods: {
    handleSubmit() {
      if (this.email === "") {
        this.errors.email.active = true;
        this.errors.email.message = "El correo es un campo necesario";
        return;
      }
      if (this.password === "") {
        this.errors.password.active = true;
        this.errors.password.message = "La contraseña es un campo necesario";
        return;
      }
      if (this.name === "") {
        this.errors.name.active = true;
        this.errors.name.message = "El nombre es un campo necesario";
        return;
      }
      if (this.type == "particular" && this.last_name === "") {
        this.errors.last_name.active = true;
        this.errors.last_name.message = "El apellido es un campo necesario.";
        return;
      }
      if (this.postal_code === "") {
        this.errors.last_name.active = true;
        this.errors.last_name.message = "El apellido es un campo necesario.";
        return;
      }
      if (this.year === "") {
        this.errors.name.active = true;
        this.errors.name.message = "El año es un campo necesario";
        return;
      }
      if (this.model === "") {
        this.errors.name.active = true;
        this.errors.name.message = "El modelo es un campo necesario";
        return;
      }
      if (this.brand === "") {
        this.errors.name.active = true;
        this.errors.name.message = "El marca es un campo necesario";
        return;
      }

      this.attemptRegister();
    },
    async attemptRegister() {
      let vm = this;
      this.errors.email.active = false;
      this.errors.password.active = false;
      this.errors.name.active = false;
      this.errors.last_name.active = false;
      this.errors.postal_code.active = false;
      this.errors.year.active = false;
      this.errors.model.active = false;
      this.errors.brand.active = false;

      try {
        vm.loading = true;
        vm.error = "";

        let { data } = await axios
          .post("/register", {
            type: vm.type,
            email: vm.email,
            password: vm.password,
            name: vm.name,
            last_name: vm.last_name,
            postal_code: vm.postal_code,
            year: vm.year,
            model: vm.model.Nombre,
            brand: vm.brand.Nombre,
          })
          .then((response) => {
            if (
              !!response.data.error &&
              response.data.error == "account_exists"
            ) {
              vm.$swal({
                icon: "info",
                title: "Esta cuenta ya existe",
                text: response.data.message + "\n" + response.data.email,
              });
            } else {
              vm.registered = true;
            }
          })
          .catch((err) => {
            vm.error = err.data?.message
              ? err.data.message
              : "Ha ocurrido un error. Verifique su información e intente de nuevo";
          })
          .finally((res) => {
            vm.loading = false;
          });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getSuburbs() {
      try {
        this.isActive = true;
        const { data } = await axios.get(
          `https://api-sepomex.hckdrk.mx/query/get_colonia_por_cp/${this.form.zip_code}`
        );
        this.suburbs = data.response.colonia;
        this.isActive = false;
      } catch (error) {
        this.isActive = false;
        console.log("Ocurrio un error: ", error);
      }
    },
    ...mapActions(["getAuth"]),

    async getYears() {
      try {
        const { data } = await axios.post("/api/bluebook/quote-car");
        this.years = data.ObtenerAniosResult.Catalogo;
      } catch (error) {
        console.error(error);
      }
    },
    async getBrands() {
      try {
        this.loadingBrand = true;
        const { data } = await axios.post("/api/bluebook/quote-car", {
          key_year: this.year,
        });
        this.brands = Array.isArray(data.ObtenerMarcasPorAnioResult.Catalogo)
          ? data.ObtenerMarcasPorAnioResult.Catalogo
          : [data.ObtenerMarcasPorAnioResult.Catalogo];
        this.loadingBrand = false;
      } catch (err) {
        this.loadingBrand = false;
        console.log("error", err);
      }
    },
    async getModels() {
      try {
        this.loadingModel = true;
        const { data } = await axios.post("/api/bluebook/quote-car", {
          key_year: this.year,
          key_brand: this.brand.Clave,
        });
        this.models = Array.isArray(
          data.ObtenerModelosPorAnioMarcaResult.Catalogo
        )
          ? data.ObtenerModelosPorAnioMarcaResult.Catalogo
          : [data.ObtenerModelosPorAnioMarcaResult.Catalogo];
        this.loadingModel = false;
      } catch (err) {
        this.loadingModel = false;
        console.log("error", err);
      }
    },
    pickSelect(id) {
      let param = {};

      switch (id) {
        case "year":
          this.models = [];
          this.model = "";
          this.brands = [];
          this.brand = "";
          this.getBrands();
          break;
        case "brand":
          this.getModels();
        default:
          break;
      }
    },
  },

  mounted() {
    this.getYears();
  },
};
</script>

<template>
  <div
    class="lightbox wrapper__form__auth bg-white flex flex-column sm:flex-row justify-content-between rounded-6 mb-4 sm:mb-10"
  >
    <div class="flex-a px-4 py-6 md:px-12 md:pt-8 md:pb-15 w-100 mb-5 sm:mb-0">
      <img
        class="auth_logo mb-1"
        src="/assets/images/layout/AD_Logo/PNG/AutoDeal_Logo_Digital.png"
        alt="AutoDeal"
      />
      <p class="tx-26 tx-grey-1 mb-6">Crea tu cuenta gratis.</p>
      <form @submit.prevent="handleSubmit()">
        <div class="form-group mb-5">
          <label class="form-label form-label--auth">
            <span>Nombre</span>
          </label>
          <div class="relative">
            <input
              v-model="name"
              class="form-input form-input--auth"
              type="text"
              :class="{ error: errors.name.active }"
              :disabled="registered"
            />
            <span class="label_error">incorrecto</span>
          </div>
        </div>
        <div class="form-group mb-5">
          <label class="form-label form-label--auth"> Apellidos </label>
          <div class="relative">
            <input
              v-model="last_name"
              class="form-input form-input--auth"
              type="text"
              :class="{ error: errors.last_name.active }"
              :disabled="registered"
            />
            <span class="label_error">incorrecto</span>
          </div>
        </div>

        <div class="form-group mb-5">
          <label class="form-label form-label--auth">
            <span>CÓDIGO POSTAL</span>
          </label>
          <div class="relative">
            <input
              v-model="postal_code"
              class="form-input form-input--auth"
              type="number"
              v-mask="'#####'"
              minlength="5"
              :class="{ error: errors.postal_code.active }"
              :disabled="registered"
            />
            <span class="label_error">incorrecto</span>
          </div>
        </div>

        <div class="form-group mb-5">
          <label class="form-label form-label--auth"> CORREO </label>
          <div class="relative">
            <input
              v-model="email"
              class="form-input form-input--auth"
              type="email"
              :class="{ error: errors.email.active }"
              :disabled="registered"
            />
            <span class="label_error" v-show="errors.email.active"
              >incorrecto</span
            >
          </div>
        </div>

        <div class="form-group mb-5">
          <label class="form-label form-label--auth"> CREAR PASSWORD </label>
          <div class="form-inner">
            <div class="form-helper form-helper--auth">
              <img
                class="auth_icon_eye"
                src="/assets/images/helpers/eye-regular.svg"
                alt=""
              />
            </div>
            <input
              v-model="password"
              class="form-input form-input--auth"
              type="password"
              :class="{ error: errors.password.active }"
              :disabled="registered"
            />
            <span class="label_error">incorrecto</span>
          </div>
        </div>
        
        <div class="form-group">
          <label class="form-label form-label--auth"> ¿QUÉ AUTO MANEJAS? </label>

          <v-select
            :options="years"
            class="form-input form-input--big form-input--v-select"
            name="year"
            :reduce="(year) => year.Clave"
            id="year"
            label="Nombre"
            v-model="year"
            @input="pickSelect('year')"
            :loading="loading"
            placeholder="Selecciona un año"
          >
            <template #spinner="{ loading }">
              <div
                v-if="loading"
                style="border-left-color: #000000"
                class="vs__spinner"
              ></div>
            </template>
            <span slot="no-options">Sin resultados</span>
          </v-select>


        </div>
        <div class="form-group">

          <v-select
            placeholder="Seleccionar marca"
       
            label="Nombre"
            :options="brands"
            :disabled="year == ''"
            @input="pickSelect('brand')"
            required
            v-model="brand"
            :loading="loadingBrand"
            class="form-input form-input--big form-input--v-select"
            name="brand"
            id="brand"
          >
            <template #spinner="{ loadingBrand }">
              <div
                v-if="loadingBrand"
                style="border-left-color: #000000"
                class="vs__spinner"
              ></div>
            </template>
            <span slot="no-options">Sin resultados</span>
          </v-select>

        </div>

        <div class="form-group">

          <v-select
            placeholder="Seleccionar modelo"
            label="Nombre"
            :options="models"
            :disabled="brand == ''"
            :loading="loadingModel"
            required
            v-model="model"
            class="form-input form-input--big form-input--v-select"
            name="model_id"
            id="model_selected"
          >
            <template #spinner="{ loadingModel }">
              <div
                v-if="loadingModel"
                style="border-left-color: #000000"
                class="vs__spinner"
              ></div>
            </template>
            <span slot="no-options">Sin resultados</span>
          </v-select>

        </div>

        <div v-if="error" class="alert alert--warning p-2 fs-12 mb-4">
          <strong>Error:</strong> {{ error }}
        </div>
        <div v-if="registered" class="alert alert--success p-2 fs-12 mb-4">
          <strong>Hemos creado tu perfil de usuario.</strong> Por favor sigue el
          enlace que te enviamos por email para confirmar tu cuenta.
        </div>
        <div v-else>
          <input
            class="btn btn--green-ad btn--submit-auth tx-14 weight-500 w-full"
            type="submit"
            value="Creando cuenta, espere..."
            v-if="loading"
            disabled
          />
          <input
            class="btn btn--green-ad btn--submit-auth tx-14 weight-500 w-full"
            type="submit"
            value="Crear mi cuenta"
            v-else
          />
        </div>

        <hr />
        <a
          class="trigger_login tx-12 tx-grey-1 underline"
          @click="$emit('login')"
        >
          Ya tengo una cuenta
        </a>
      </form>
    </div>
    <div
      class="render_bg_auth hidden sm:flex bg-cover bg-no-repeat bg-center align-items-end flex-none rounded-tr-4 rounded-br-4 p-4 md:px-10 md:py-5"
      style="background-image:url('/assets/images/layout/Inicio-Sesion.jpg"
    >
      <!-- RENDER BG -->
    </div>
  </div>
</template>
